import { VariantProps } from "class-variance-authority";
import {
  DropZoneProps,
  DropZone as ReactAriaCDropZone,
  Text as ReactAriaText,
} from "react-aria-components";

import { cn, cv } from "../utils";

const ncDropZoneVariants = cv(
  [
    "data-focus-visible:outline-active data-focus-visible:outline-2 data-focus-visible:outline-offset-2",
    "group data-drop-target:bg-active/25 data-drop-target:outline-active data-drop-target:outline-2 data-drop-target:-outline-offset-1",
  ],
  {
    variants: {
      variant: {
        default:
          "border-ui bg-light flex min-h-24 items-center justify-center rounded-lg border-2 border-dashed p-4 text-center text-balance",
        trigger: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export type NcDropZoneProps = DropZoneProps & VariantProps<typeof ncDropZoneVariants>;

export const NcDropZone = ({ variant, className, ...props }: NcDropZoneProps) => {
  return (
    <ReactAriaCDropZone
      data-nc="NcDropZone"
      {...props}
      className={cn(ncDropZoneVariants({ variant }), className)}
    />
  );
};

const NcDropZoneText = ({ ...props }) => <ReactAriaText slot="label" {...props} />;

NcDropZone.Text = NcDropZoneText;
